module.exports = __webpack_public_path__ + "img/sb-my.ced099d6.png";